import Model from "../../model"
import assert from "../../../services/assert"
import { ID, IdeaFieldName } from "../../types"

import Command, { CommandName } from "../command"

export type SetIdeaFieldCommandState = {
  id: ID
  field: IdeaFieldName
  value: any
  selectionPos: number | null
  updatedAt?: Date
  editedAt?: Date
  captured?: {
    prevValue: any
    didConnectionsChange?: boolean
  }
}

export default class SetIdeaFieldCommand extends Command {
  name: CommandName = "set-idea-field"
  state: SetIdeaFieldCommandState

  constructor(state: SetIdeaFieldCommandState) {
    super()
    this.state = state
    assert(
      !["location", "connections", "sourceType", "sourceId"].includes(
        this.state.field
      )
    )
  }

  // Possible conflicts:
  //   - idea might have been deleted (Cancel)
  resolveConflicts(model: Model): SetIdeaFieldCommandState | null {
    const idea = model.getIdea(this.state.id)
    if (!idea) return null
    return this.state
  }

  local(model: Model): any {
    const idea = model.fetchIdea(this.state.id)
    if (idea.type === "fleeting")
      console.log("SetIdeaFieldCommand being called for a fleeting note")

    const prevValue = idea[this.state.field]
    let didConnectionsChange: boolean = false

    if (this.state.field === "content")
      didConnectionsChange = model.setIdeaContent(
        this.state.id,
        this.state.value,
        this.state.updatedAt,
        this.state.editedAt,
      )
    else {
      model.setIdeaField(
        this.state.id,
        this.state.field,
        this.state.value,
        this.state.updatedAt,
        this.state.editedAt,
      )
    }

    this.state.captured = { prevValue, didConnectionsChange }
  }

  undo(): Command[] {
    if (!this.state.captured) throw new Error("Undo state not set")
    return [
      new SetIdeaFieldCommand({
        id: this.state.id,
        field: this.state.field,
        value: this.state.captured.prevValue,
        selectionPos: this.state.selectionPos,
      }),
    ]
  }

  redo(): Command {
    return new SetIdeaFieldCommand({
      id: this.state.id,
      field: this.state.field,
      value: this.state.value,
      selectionPos: this.state.selectionPos,
    })
  }

  merge(previous: Command | undefined): Command | undefined {
    if (
      previous instanceof SetIdeaFieldCommand &&
      this.state.id === previous.state.id &&
      this.state.field === previous.state.field &&
      this.timestamp - previous.timestamp < 5000
    ) {
      const merged = new SetIdeaFieldCommand({
        id: this.state.id,
        field: this.state.field,
        value: this.state.value,
        selectionPos: this.state.selectionPos,
      })
      merged.state.captured = previous.state.captured
      return merged
    }
  }

  openIdea(): [ID, number] {
    return [this.state.id, this.state.selectionPos || 0]
  }
}
